import { render } from "./BarcodeChildren.vue?vue&type=template&id=2a93c172"
import script from "./BarcodeChildren.vue?vue&type=script&lang=ts"
export * from "./BarcodeChildren.vue?vue&type=script&lang=ts"
script.render = render

export default script